import React, { useEffect, useState } from "react";
import { baseUrl } from "../../Config/baseUrl";
import { GetPaymentFeed } from "../../Services/TransactionFeed";
import Pagination from "@mui/material/Pagination";
import TransactionFeedSkeleton from "./TransactionFeedSkeleton";

const TransactionFeed = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const fetchPaymentFeed = async (page) => {
    setLoading(true);
    try {
      const res = await GetPaymentFeed({ page, search: search });

      setData(res?.data || []);

      setLoading(false);
    } catch (err) {
      throw new Error(err);
    }
  };
  useEffect(() => {
    fetchPaymentFeed(page);
  }, [page, search]);
  const handleChange = (e, value) => {
    setPage(value);
  };

  return (
    <div>
      <div className="max-w-5xl mx-auto px-4 py-6">
        <p className="md:text-2xl text-lg font-bold text-black pb-2">
          Transaction History
        </p>
        <div className="py-4">
          <input
            type="text"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
            placeholder="Search Your Transaction Here..."
            className="w-full  border px-4 py-2 rounded-md"
          />
        </div>

        {loading ? (
          <TransactionFeedSkeleton />
        ) : data?.data?.length > 0 ? (
          <>
            <div className="overflow-x-auto bg-white shadow-md rounded-lg border border-gray-200">
              <table className="w-full text-sm text-left text-gray-700 min-w-[600px]">
                <thead className="text-xs text-gray-500 uppercase bg-gray-50 border-b">
                  <tr>
                    <th scope="col" className="px-4 py-3">
                      Name
                    </th>
                    <th scope="col" className="px-4 py-3">
                      Payment ID
                    </th>
                    <th scope="col" className="px-4 py-3">
                      Amount
                    </th>
                    <th scope="col" className="px-4 py-3">
                      Date
                    </th>
                    <th scope="col" className="px-4 py-3">
                      Status
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data?.data?.map((tx) => (
                    <tr
                      key={tx?.id}
                      className="border-b hover:bg-gray-50 transition-all"
                    >
                      <td className="px-4 py-3">
                        <p className="font-medium">{tx?.name}</p>
                        <p className="text-xs text-gray-500">{tx?.phone}</p>
                      </td>
                      <td className="px-4 py-3">
                        <p className="font-meduim">{tx?.payment_no}</p>
                      </td>
                      <td className="px-4 py-3 font-semibold text-green-600">
                        &#8377;
                        {tx?.amount?.toLocaleString()}
                      </td>
                      <td className="px-4 py-3 text-gray-600">
                        {new Date(tx?.created_date).toLocaleDateString()}{" "}
                        {new Date(tx?.created_date).toLocaleTimeString([], {
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </td>
                      <td className="px-4 py-3">
                        <span
                          className={`px-2 py-1 rounded-full text-xs font-semibold ${
                            tx?.status === "Paid"
                              ? "bg-green-100 text-green-600"
                              : tx?.status === "Pending"
                              ? "bg-yellow-100 text-yellow-600"
                              : "bg-red-100 text-red-600"
                          }`}
                        >
                          {tx?.status}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="flex items-center justify-center pt-2">
              <Pagination
                count={data?.count}
                page={page}
                onChange={handleChange}
                color="primary"
              />
            </div>
          </>
        ) : (
          <div className="flex flex-col items-center justify-center py-12">
            <img
              src="https://plus.unsplash.com/premium_photo-1682339458660-bc746ad86023?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8bm8lMjB0cmFuc2FjdGlvbiUyMGhpc3RvcnklMjBmb3VuZHxlbnwwfHwwfHx8MA%3D%3D"
              alt="No data"
              className="w-48 h-48 object-contain mb-4"
            />
            <p className="text-gray-500 text-center text-sm">
              No transaction history found.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default TransactionFeed;
